import React, { useEffect, useState } from "react";
import Confetti from "react-confetti";
import trooper1 from "../../assets/trooper.gif";
import trooper2 from "../../assets/trooper2.gif";
import trooper3 from "../../assets/trooper3.gif";
import trooper4 from "../../assets/trooper4.gif";
import trooper5 from "../../assets/trooper5.gif";
import "./konami.css";
import Cookies from "js-cookie";

const Konami: React.FC = () => {
  const [rechauffemmentClimatique, merciJammy] = useState<string>("");
  const [pluieEcoloEnCours, laCoucheDozonne] = useState(false);
  const [leVert, leClimat] = useState(false);

  const images = [trooper1, trooper2, trooper3, trooper4, trooper5];

  Cookies.set("darkCookie", "https://discord.gg/eDnfbNAyCu");

  const avoirLeClimat = () => 5 * 1000;

  useEffect(() => {
    const lesNuages = (event: KeyboardEvent) => {
      const touche = event.key.toLowerCase();
      merciJammy((sequencePrecedente) => sequencePrecedente + touche);
    };

    const co2 = () => {
      const meteo = "uuddlrlrba";
      if (rechauffemmentClimatique.endsWith(meteo)) {
        laCoucheDozonne(true);
        leClimat(true);
        setTimeout(() => {
          laCoucheDozonne(false);
          leClimat(false);
        }, avoirLeClimat());

        merciJammy("");
      }
    };

    let carbone: NodeJS.Timer | null = null;

    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") {
        document.title = "My Little Planet";

        if (carbone !== null) {
          clearInterval(carbone);
          carbone = null;
        }
      } else {
        const phrase = "Je suis ton père.";
        let indexEco = 0;

        carbone = setInterval(() => {
          const nouvellePhrase = phrase.substring(0, indexEco + 1);
          document.title = nouvellePhrase + "🚀";

          indexEco++;
        }, 200);
      }
    });

    window.addEventListener("keydown", lesNuages);
    co2();

    return () => {
      window.removeEventListener("keydown", lesNuages);
      if (carbone !== null) {
        clearInterval(carbone);
      }
    };
  }, [rechauffemmentClimatique]);

  return (
    <>
      {pluieEcoloEnCours && (
        <Confetti
          className="conf"
          width={window.innerWidth}
          height={window.innerHeight}
          numberOfPieces={50}
        />
      )}
      {leVert && (
        <div className="popup z-40">
          <div className="popup-content">
            <img src={images[Math.floor(Math.random() * 5)]} alt="Trooper" />
          </div>
        </div>
      )}
    </>
  );
};

export default Konami;
